(function () {
  function formatMoney(cents, currency) {
    return new Intl.NumberFormat(
      document.documentElement.lang || 'en',
      {
        style: 'currency',
        currency: currency || 'EUR'
      }
    ).format(cents / 100);
  }

  function updateSmartPack(selector, button) {
    if (!selector || !button || button.disabled) return;

    const qty = parseInt(button.dataset.qty, 10);
    const packPrice = parseInt(
      button.dataset.packPrice || '0',
      10
    );

    if (!qty || !packPrice) {
      return;
    }

    const compareAtPrice = parseInt(
      selector.dataset.compareAtPrice || '0',
      10
    );

    const currency =
      selector.dataset.currency || 'EUR';

    /*
     * Product unit configuration.
     *
     * Examples:
     * Can
     * Piece
     * Pouch
     *
     * Falls back to "Can" for products
     * that have not yet been migrated.
     */
    const unitSingular =
      selector.dataset.unitSingular || 'Can';

    const unitLabel =
      unitSingular.toLowerCase();

    selector
      .querySelectorAll('[data-smart-pack-button]')
      .forEach(function (item) {
        item.classList.remove('is-active');
      });

    button.classList.add('is-active');

    /*
     * Find Smart Pack quantity input.
     *
     * Card selector contains the input.
     * PDP may have the input elsewhere
     * inside the product form.
     */
    let quantityInput = selector.querySelector(
      '[data-smart-pack-quantity]'
    );

    if (!quantityInput) {
      const form = selector.closest('form');

      if (form) {
        quantityInput = form.querySelector(
          '[data-smart-pack-quantity]'
        );
      }
    }

    if (!quantityInput) {
      const productInfo =
        selector.closest('product-info');

      if (productInfo) {
        quantityInput = productInfo.querySelector(
          '[data-smart-pack-quantity], input[name="quantity"]'
        );
      }
    }

    if (quantityInput) {
      quantityInput.value = qty;

      quantityInput.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );

      quantityInput.dispatchEvent(
        new Event('input', {
          bubbles: true
        })
      );
    }

    /*
     * Pricing calculations
     */
    const originalTotal =
      compareAtPrice * qty;

    const activePerUnit =
      packPrice / qty;

    let savingPercent = 0;

    if (
      originalTotal > packPrice &&
      originalTotal > 0
    ) {
      savingPercent = Math.round(
        (
          (originalTotal - packPrice) /
          originalTotal
        ) * 100
      );
    }

    const originalTotalEl =
      selector.querySelector(
        '[data-smart-pack-original-total]'
      );

    const activeTotalEl =
      selector.querySelector(
        '[data-smart-pack-active-total]'
      );

    const savingEl =
      selector.querySelector(
        '[data-smart-pack-saving]'
      );

    const originalPerUnitEl =
      selector.querySelector(
        '[data-smart-pack-original-per-can]'
      );

    const activePerUnitEl =
      selector.querySelector(
        '[data-smart-pack-active-per-can]'
      );

    /*
     * Original total
     */
    if (originalTotalEl) {
      originalTotalEl.textContent =
        compareAtPrice > 0
          ? formatMoney(
              originalTotal,
              currency
            )
          : '';
    }

    /*
     * Active Smart Pack total
     */
    if (activeTotalEl) {
      activeTotalEl.textContent =
        formatMoney(
          packPrice,
          currency
        );
    }

    /*
     * Original price per unit
     */
    if (originalPerUnitEl) {
      originalPerUnitEl.textContent =
        compareAtPrice > 0
          ? formatMoney(
              compareAtPrice,
              currency
            ) +
            ' per ' +
            unitLabel
          : '';
    }

    /*
     * Active price per unit
     */
    if (activePerUnitEl) {
      activePerUnitEl.textContent =
        formatMoney(
          activePerUnit,
          currency
        ) +
        ' per ' +
        unitLabel;
    }

    /*
     * Saving percentage
     */
    if (savingEl) {
      savingEl.textContent =
        savingPercent > 0
          ? 'Save ' +
            savingPercent +
            '%'
          : '';
    }
  }

  /*
   * Event delegation allows the selector
   * to continue working when Shopify
   * dynamically re-renders sections.
   */
  document.addEventListener(
    'click',
    function (event) {
      const button =
        event.target.closest(
          '[data-smart-pack-button]'
        );

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      const selector =
        button.closest(
          '[data-smart-pack-selector]'
        );

      updateSmartPack(
        selector,
        button
      );
    }
  );

  /*
   * Initialize all selectors with their
   * default active pack.
   */
  function initializeSmartPackPricing() {
    document
      .querySelectorAll(
        '[data-smart-pack-selector]'
      )
      .forEach(
        function (selector) {
          const activeButton =
            selector.querySelector(
              '[data-smart-pack-button].is-active'
            );

          if (activeButton) {
            updateSmartPack(
              selector,
              activeButton
            );
          }
        }
      );
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initializeSmartPackPricing
    );
  } else {
    initializeSmartPackPricing();
  }
})();